'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components2 = require('components');

var _forms = require('utils/forms');

var _pacomo = require('utils/pacomo');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoadingIndicator = function LoadingIndicator(_ref) {
    var _ref$inline = _ref.inline,
        inline = _ref$inline === undefined ? false : _ref$inline,
        _ref$apiCalls = _ref.apiCalls,
        apiCalls = _ref$apiCalls === undefined ? [] : _ref$apiCalls,
        mustExist = _ref.mustExist,
        children = _ref.children;

    var canLoad = apiCalls.every(function (apiCall) {
        return apiCall.canLoad;
    });
    var errors = apiCalls.filter(function (apiCall) {
        return apiCall.error;
    }).map(function (x) {
        return x.error;
    });

    if (mustExist && canLoad) {
        mustExist.forEach(function (valueErr) {
            if (!valueErr.value) {
                errors.push(valueErr.error);
            }
        });
    }

    if (errors.length > 0) {
        return _react2.default.createElement(
            'div',
            null,
            errors.map(function (error, i) {
                return _react2.default.createElement(
                    'div',
                    { className: 'alert', role: 'alert', key: i },
                    _react2.default.createElement(
                        'p',
                        null,
                        error
                    )
                );
            })
        );
    } else if (!canLoad) {
        return _react2.default.createElement(_components2.IconLoading, { inline: inline });
    } else if (children) {
        return inline ? _react2.default.createElement(
            'span',
            null,
            children
        ) : _react2.default.createElement(
            'div',
            null,
            children
        );
    } else {
        return null;
    }
};
LoadingIndicator.propTypes = {
    inline: _propTypes2.default.bool,
    apiCalls: _propTypes2.default.array,
    mustExist: _propTypes2.default.array,
    children: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array])
};
exports.default = (0, _pacomo.pacomoTransformer)(LoadingIndicator);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/components/LoadingIndicator.js
// module id = 1300
// module chunks = 0